<div class="spb-holder">
  <spb-header></spb-header>
  <router-outlet></router-outlet>
  <div class="spb-filler"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    [license]="true"
    [version]="version"
    [token]="configService.accessToken()"
    [copyrightYears]="copyrightYears"
  ></spb-footer>
</div>

